const animates = document.querySelectorAll(".animate");
const observer = new IntersectionObserver(
    entries => {
        entries.forEach(entry => {
            entry.target.classList.toggle("in-view", entry.isIntersecting);
            var animate = entry.target.getAttribute('data-animate');
            if(animate){
                entry.target.classList.toggle("animate__animated", entry.isIntersecting);
                entry.target.classList.toggle(animate, entry.isIntersecting);
            } 
            if(entry.isIntersecting) observer.unobserve(entry.target);            
        });
    },
    {
        threshold: 0.25
    }
);
animates.forEach(animate => {
    observer.observe(animate);
});

const intl_phone = document.querySelector("#input-tel");
if(intl_phone){
    window.intlTelInput(intl_phone, {
        hiddenInput : "input-tel-full",
        preferredCountries : ["br", "us", "ca", "gb", "pt"],
        separateDialCode : true,
        placeholderNumberType : "MOBILE",
        utilsScript : "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
    });
}

const intl_celphone = document.querySelector("#input-cel");
if(intl_celphone){
    window.intlTelInput(intl_celphone, {
        hiddenInput : "input-tel-full",
        preferredCountries : ["br", "us", "ca", "gb", "pt"],
        separateDialCode : true,
        placeholderNumberType : "MOBILE",
        utilsScript : "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
    });
}

jQuery(function($){

    $('.animate-hover').on('mouseenter', function(){
        var animate = $(this).attr('data-animate');
        if(animate){
            var animated = 'animate__animated ' + animate;
            $(this).addClass(animated);
        }
    }).on('mouseleave', function(){
        var animate = $(this).attr('data-animate');
        if(animate){
            var animated = 'animate__animated ' + animate;
            $(this).removeClass(animated);
        }
    });

    $(".nav-link").on('click', function() {   
        var aria_control = '#' + $(this).attr('aria-controls');
        $('html, body').animate({
            scrollTop: $(aria_control).offset().top-150
        }, 0);
    });

    var carousel = $('.carousel');
    if(carousel.length){
        $('#prev-quotes').on('click', function(e){
            e.preventDefault();
            carousel.slick('slickPrev');
        });
        $('#next-quotes').on('click', function(e){
            e.preventDefault();
            carousel.slick('slickNext');
        });
        carousel.slick({
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
        
    }

    var galeryItems = $('.wp-block-gallery');
    if(galeryItems.length){
        galeryItems.each(function(index){            
            $(this).children('.wp-block-image').children('a').attr('data-lightbox', 'roadtrip-'+index);
        });
        lightbox.option({
            'albumLabel': "Imagem %1 de %2",
            'wrapAround': true
        });
    }
    


});